import CourseProducts from './CourseProducts';

export default CourseProducts;
